import 'unfetch/polyfill';
import {openInfoWindow} from './PopupContentDialog';
import {buildHtml} from './PopupContentDialog';
import {loadMapPinContent} from './PopupContentDialog';


export async function loadMapPins(dataSource, gMap) {
  const hostname = '//' + location.hostname;
  const endpointPath = '/data/map/GetCustomMapPins/?dataSource=';
  const Modernizr = window.Modernizr;
  try {
    const response = await fetch(hostname + endpointPath + dataSource);
    const data = await response.json();

    gMap.infoWindow = new google.maps.InfoWindow({
      minWidth: 280,
      maxWidth: 380,
    });

    const mapData = data.map((m) => {
      var iconUrl = '';

      if (m.IconUrl != null && m.IconUrl != '') {
        iconUrl = hostname + m.IconUrl;
      }
      if(m.PinType == null || m.PinType == "mapPin"){
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(m.Lat, m.Lng),
          title: m.Title,
          map: gMap,
          icon: iconUrl,
        });

        marker.popupHtml = buildHtml(m);
        marker.addListener('click', () => {
          openInfoWindow(gMap, marker);
        });
        gMap.markers.push(marker);
      }
      else if(m.PinType == "gisMapPin"){
        var pinImagePath = '/assets/NPWS/images/map-pins/';
        
        var pinIcon;
        if (
          typeof m.PSubType !== 'undefined' && m.PSubType !== null && m.PSubType !== '') {
          pinIcon = m.PSubType;
        } else {
          pinIcon = m.PType;
        }

        if (m.PType == 'subatt') {
          pinImagePath += 'subattraction/';
        }

        var pinWidth = 0;
        var pinHeight = 0;

        //if (module.pins.canonicalizeId(pin.id) == module.pins.canonicalizeId(mapSettings.selected)) {
        if (m.PTemplate == 't3') {
          pinIcon = 't3-park';
          pinWidth = 24;
          pinHeight = 28;
        } else {
          pinWidth = 34;
          pinHeight = 39;
        }
        var image;
        if (Modernizr.highres && m.PType != 'subatt') {
          // Detect retina displays and load high res pin if necessary
          image = new google.maps.MarkerImage(
            pinImagePath + '/retina/' + pinIcon + '.png',
            null,
            null,
            null,
            new google.maps.Size(pinWidth, pinHeight)
            // null null null does some google magic to make the images size properly for retina
          );
        } else {
          image = new google.maps.MarkerImage(
            pinImagePath + pinIcon + '.png',
            new google.maps.Size(pinWidth, pinHeight)
          );
        }
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(m.Lat, m.Lng),
          title: m.Title,
          map: gMap,
          //icon: iconUrl,
          icon: image
        });
        marker.pinHeight = pinHeight;
        if(m.HasOverrideDescription){
          marker.popupHtml = buildHtml(m);
        }else{
          marker.popupHtml = "";
        }
        marker.hasSourceItem=m.HasSourceItem;
        marker.sourceItem=m.SourceItem;
        
        marker.addListener('click', () => {
          if(m.HasOverrideDescription){
            openInfoWindow(gMap, marker);
          }else if(marker.hasSourceItem){
            loadMapPinContent(marker);
          }
        });
        gMap.markers.push(marker);
      }
      
    });

    gMap.setInitialView();
  } catch (error) {
    console.warn(`Request issue ${error}`);
  }
}
